module.exports = __webpack_public_path__ + "img/karpicko_2021_sm.f596c3ae.png";